import gql from "graphql-tag";

export const SUBSCRIPTIONS_QUERY = gql`
  query subscriptionsQuery($userId: ID!, $surveySubmittedDate_Lte: Date) {
    subscriptions(userId: $userId) {
      id
      active
      startDate
      endDate
      subscriptionsurveySet(submittedDate_Lte: $surveySubmittedDate_Lte) {
        edges {
          node {
            id
            survey {
              id
              title
              surveyType
            }
          }
        }
      }
      transitionProductVariant {
        id
        title
        product {
          id
          title
        }
      }
      billingOrder {
        id
      }
      product {
        id
        name
        type
      }
    }
  }
`;

export const SUBSCRIPTION_QUERY = gql`
  query subscriptionQuery($id: ID!) {
    subscriptionById(id: $id) {
      id
      startDate
      endDate
      serviceStartDate
      stage
      active
      programStartDate
      subscriptioncancellationreasonSet {
        id
        comment
        cancellationReason {
          id
          reason
        }
      }
      transitionProductVariant {
        id
      }
      product {
        id
        name
      }
      userPrograms {
        id
        programStartDate
        coach {
          id
          firstName
          lastName
        }
        nutritionPlan {
          id
          name
        }
        program {
          id
          name
        }
      }
      subscriptionProcessChecks {
        user {
          id
          firstName
          lastName
        }
        type
      }
      billingOrder {
        id
        orderStatus
        nextBillingDate
        transactionMethod
        paymentMethod
        currency
        shippingAmount
        discountAmount
        customerNotes
        referralCode
        billingStartDate
        billingDay
        billingPeriod
        cancellationDate
        staffNotes
        pausePaymentUntilDate
        suspensionDate
        discounts {
          edges {
            node {
              id
              title
              createdByUser {
                id
                firstName
                lastName
              }
              isPromotion
              maxUses
              numberOfUses
              startDate
              endDate
              newUsersOnly
              restrictedToUser {
                id
                email
              }
              flatDiscount
              percentageDiscount
            }
          }
        }
        payments {
          id
          billingDate
          paymentStatus
          retries
          totalAmount
          discountAmount
          country
          transactionSet {
            id
            transactionStatus
            gatewayResponse
            gatewayReference
          }
        }
      }
      orders {
        id
        closedAt
        number
        shopifyCustomerId
        shopifyOrderId
        totalPrice
        sku
        name
      }
      product {
        id
        name
      }
      coach {
        id
        firstName
        lastName
      }
      supportOwner {
        id
        firstName
        lastName
      }
      connectOwner {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
      product {
        name
        type
      }
    }
  }
`;

export const CANCELLATION_REASONS_QUERY = gql`
  query cancellationReasonsQuery {
    cancellationReasons {
      id
      reason
    }
  }
`;

export const UPDATE_SUBSCRIPTION_MUTATION = gql`
  mutation updateSubscriptionRecord($input: EditSubscriptionInput!) {
    updateSubscriptionRecord(input: $input) {
      error
      updated
    }
  }
`;

export const END_SUBSCRIPTION_MUTATION = gql`
  mutation processSubscriptionCancellation($input: SubscriptionCancellationInput!) {
    processSubscriptionCancellation(input: $input) {
      error
      success
    }
  }
`;

export const BILLING_PRODUCTS_QUERY = gql`
  query billingProductsQuery {
    billingProducts {
      edges {
        node {
          id
          title
          image
          code
          requiresActiveSubscription
          productvariantSet {
            edges {
              node {
                id
                title
                description
                code
                billingPeriod
                isDefault
                product {
                  id
                  title
                  productCategory {
                    id
                    title
                  }
                }
                productvariantpriceSet {
                  id
                  price
                  currency
                }
              }
            }
          }
        }
      }
    }
  }
`;
